import { reactive } from "vue";
import i18n from "../../../../i18n";
import { createLoading } from "../../../../utils/loading";
import {
    createManageExportCsv,
    createManageSelect,
    createPage,
} from '../../../../utils/page';
import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber
} from '../../../../components/table/c-table.logic';
import store from '../../../../store';
import moment from "moment"

export const callSearchSamplingProductAnalysis = ({ criteria }) => store.dispatch(`resource/v1/transaction/samplingProductAnalysis/search`, { criteria })

export const { isLoading, setIsLoading } = createLoading()

export const onSearch = ({ page, props}) => {

    setIsLoading(true);

    const { where = [] } = page;

    window.onSearch?.({ page });

    where.push(
        { name: "refLabType.key", operator: '=', type: 'String', value: props.refLabTypeKey },
        { name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: 'in', value: ['L', 'S'] }
    )

    return callSearchSamplingProductAnalysis({
        criteria: {
            ...page,
            where: [...where],
            data: []
        }
    })
        .then(page => {
            page.data.forEach(it => {
                let samplingReceiveDate;
                let approveDate;
                let workDay;
                if (it.samplingReceiveDate) {
                    samplingReceiveDate = moment(it.samplingReceiveDate.split('-'))
                }
                if (it.approveDate) {
                    approveDate = moment(it.approveDate.split('-'))
                }
                if (samplingReceiveDate && approveDate) {
                    workDay = approveDate.diff(samplingReceiveDate, "days") + 1
                }
                it.workDay = workDay;
            })
            state.page = { ...page } })
        .finally(() => setIsLoading(false));
};


export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.samplingProduct.samplingNo"),
            dataIndex: "refSamplingProduct.samplingNo",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.samplingRequest.samplingCollectDate"),
            dataIndex: "refSamplingProduct.refSamplingRequest.samplingCollectDate",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.samplingProductAnalysis.samplingReceiveDate"),
            dataIndex: "samplingReceiveDate",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.samplingProductAnalysis.approveDate"),
            dataIndex: "approveDate",
            align: "center"
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.report.labMicro.workTimeReport.workDay"),
            dataIndex: "workDay",
            align: "center",
            search: {
                visible: () => false
            }
        }),
    ]
    return columns
}

export const state = reactive({
    columns: [],
    page: createPage({ options: { select: ["**", "refCreateBy.fullName", "refSamplingProduct.refSamplingRequest.*"], page: 0, size: 100000000, } }),
    tableOptions: { search: { activeKey: "Search" } }
});

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    state.columns = createColumns({ props, data });
    state.manages = [
        createManageSelect({ menuContext }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [];
};


